<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post-8_natanz-damage-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post-8_natanz-damage-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.35445757250269;"
    data-aspect-ratio="0.354"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post-8_natanz-damage-xs-img"
      class="g-post-8_natanz-damage-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_natanz-damage-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.9542%;margin-top:-16.7px;left:60.604%;width:131px;"
    >
      <p class="g-pstyle1">Recent damage</p>
      <p class="g-pstyle1">in March 2026</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.8694%;margin-top:-24.7px;left:39.8701%;width:158px;"
    >
      <p class="g-pstyle0">Damaged in 2025</p>
      <p class="g-pstyle0">but appears to have</p>
      <p class="g-pstyle0">been rebuilt.</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.7394%;margin-top:-16.7px;left:9.7156%;width:166px;"
    >
      <p class="g-pstyle0">Facilities sustained</p>
      <p class="g-pstyle0">damage in June 2025</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post-8_natanz-damage-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.66841415465269;"
    data-aspect-ratio="0.668"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post-8_natanz-damage-sm-img"
      class="g-post-8_natanz-damage-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_natanz-damage-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.4003%;margin-top:-16.7px;left:46.0771%;width:131px;"
    >
      <p class="g-pstyle1">Recent damage</p>
      <p class="g-pstyle1">in March 2026</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:58.2784%;margin-top:-24.7px;left:25.7983%;width:158px;"
    >
      <p class="g-pstyle0">Damaged in 2025</p>
      <p class="g-pstyle0">but appears to have</p>
      <p class="g-pstyle0">been rebuilt.</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.1381%;margin-top:-16.7px;left:6.2866%;width:166px;"
    >
      <p class="g-pstyle0">Facilities sustained</p>
      <p class="g-pstyle0">damage in June 2025</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post-8_natanz-damage-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 917px;aspect-ratio: 1.08019639934534;"
    data-aspect-ratio="1.08"
    data-min-width="660"
    data-max-width="917"
  >
    <div
      id="g-post-8_natanz-damage-md-img"
      class="g-post-8_natanz-damage-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_natanz-damage-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.8435%;margin-top:-16.7px;left:66.9926%;width:131px;"
    >
      <p class="g-pstyle1">Recent damage</p>
      <p class="g-pstyle1">in March 2026</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.5539%;margin-top:-24.7px;left:44.2072%;width:158px;"
    >
      <p class="g-pstyle0">Damaged in 2025</p>
      <p class="g-pstyle0">but appears to have</p>
      <p class="g-pstyle0">been rebuilt.</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.0563%;margin-top:-16.7px;left:34.0336%;width:166px;"
    >
      <p class="g-pstyle0">Facilities sustained</p>
      <p class="g-pstyle0">damage in June 2025</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post-8_natanz-damage-lg"
    class="g-artboard"
    style="min-width: 918px;aspect-ratio: 1.09155766944114;"
    data-aspect-ratio="1.092"
    data-min-width="918"
  >
    <div
      id="g-post-8_natanz-damage-lg-img"
      class="g-post-8_natanz-damage-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_natanz-damage-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.5771%;margin-top:-17.7px;left:66.2424%;width:131px;"
    >
      <p class="g-pstyle1">Recent damage</p>
      <p class="g-pstyle1">in March 2026</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.0575%;margin-top:-26.2px;left:43.9113%;width:158px;"
    >
      <p class="g-pstyle0">Damaged in 2025</p>
      <p class="g-pstyle0">but appears to have</p>
      <p class="g-pstyle0">been rebuilt.</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:22.79%;margin-top:-17.7px;left:39.9897%;width:166px;"
    >
      <p class="g-pstyle0">Facilities sustained</p>
      <p class="g-pstyle0">damage in June 2025</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-04 16:18 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-04 16:18 -->
<!-- ai file: post-8_natanz-damage.ai -->
<style lang="scss">
  #g-post-8_natanz-damage-box {
    container-type: inline-size;
    container-name: g-post-8_natanz-damage-box;
  }
  #g-post-8_natanz-damage-box,
  #g-post-8_natanz-damage-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-8_natanz-damage-box p {
    margin: 0;
  }
  #g-post-8_natanz-damage-box .g-aiAbs {
    position: absolute;
  }
  #g-post-8_natanz-damage-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-8_natanz-damage-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post-8_natanz-damage-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-8_natanz-damage-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-8_natanz-damage-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-8_natanz-damage-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-8_natanz-damage-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 917px) {
      #g-post-8_natanz-damage-md {
        display: block !important;
      }
    }
    @container (min-width:918px) {
      #g-post-8_natanz-damage-lg {
        display: block !important;
      }
    }
  }
  #g-post-8_natanz-damage-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_natanz-damage-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_natanz-damage-xs .g-pstyle0 {
    font-weight: 400;
    height: 16px;
  }
  #g-post-8_natanz-damage-xs .g-pstyle1 {
    font-weight: 400;
    height: 16px;
    color: rgb(255, 212, 48);
  }
  #g-post-8_natanz-damage-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_natanz-damage-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_natanz-damage-sm .g-pstyle0 {
    font-weight: 400;
    height: 16px;
  }
  #g-post-8_natanz-damage-sm .g-pstyle1 {
    font-weight: 400;
    height: 16px;
    color: rgb(255, 212, 48);
  }
  #g-post-8_natanz-damage-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_natanz-damage-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_natanz-damage-md .g-pstyle0 {
    font-weight: 400;
    height: 16px;
  }
  #g-post-8_natanz-damage-md .g-pstyle1 {
    font-weight: 400;
    height: 16px;
    color: rgb(255, 212, 48);
  }
  #g-post-8_natanz-damage-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_natanz-damage-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_natanz-damage-lg .g-pstyle0 {
    font-weight: 400;
    height: 17px;
  }
  #g-post-8_natanz-damage-lg .g-pstyle1 {
    font-weight: 400;
    height: 17px;
    color: rgb(255, 212, 48);
  }

  /* Custom CSS */
  @mixin shadow-manchego($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      rgba($clr, $alpha) 1px 0px 0px,
      rgba($clr, $alpha) 0.540302px 0.841471px 0px,
      rgba($clr, $alpha) -0.416147px 0.909297px 0px,
      rgba($clr, $alpha) -0.989992px 0.14112px 0px,
      rgba($clr, $alpha) -0.653644px -0.756802px 0px,
      rgba($clr, $alpha) 0.283662px -0.958924px 0px,
      rgba($clr, $alpha) 0.96017px -0.279415px 0px;
  }

  @mixin shadow-feta($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.5);
    text-shadow:
      0 0 10px rgba($clr, $alpha),
      0 0 3px rgba($clr, $alpha);
  }

  @mixin shadow-provolone($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.7);
    text-shadow:
      1px 1px 0px rgba($clr, $alpha),
      0px 1px 0px rgba($clr, $alpha),
      -1px 1px 0px rgba($clr, $alpha),
      -1px 0px 0px rgba($clr, $alpha),
      -1px -1px 0px rgba($clr, $alpha),
      0px -1px 0px rgba($clr, $alpha),
      1px -1px 0px rgba($clr, $alpha);
  }

  @mixin shadow-gouda($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.9);
    text-shadow:
      1px 1px 1px rgba($clr, $alpha),
      1px -1px 1px rgba($clr, $alpha),
      -1px 1px 1px rgba($clr, $alpha),
      -1px -1px 1px rgba($clr, $alpha);
  }
  .g-shadow {
    @include shadow-manchego(#000000);
    @include shadow-feta(#000000);
  }
  .g-whiteshadow {
    @include shadow-provolone(#ffffff);
    @include shadow-gouda(#ffffff);
  }
  .g-anno {
    @include shadow-manchego(#000000);
  }
</style>
